import { render, staticRenderFns } from "./ColumnCreatedAt.vue?vue&type=template&id=4a043ce8&"
import script from "./ColumnCreatedAt.vue?vue&type=script&lang=ts&"
export * from "./ColumnCreatedAt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports